<h2>Ваша идея</h2>

<form [formGroup]="suggestForm" (ngSubmit)="onSubmit()">
  <p i18n="@@SuggestFormDescription">Вы можете указать ошибки, предложить идеи и рекомендации для нашей системы</p>
  <div class="form-content">
    <div class="form-control-group">
      <label i18n="@@YourName">Ваше имя</label>
      <input nbInput fullWidth
             type="text"
             name="name"
             formControlName="name"
             id="input-name"
             i18n-placeholder="@@Name"
             placeholder="Имя">
    </div>
    @if (suggestForm.controls.name.errors?.required && suggestForm.controls.name.touched) {
      <div class="invalid-feedback" i18n="@@EmptyLogin">укажите имя</div>
    }
  </div>
  <div class="form-content">
    <div class="form-control-group">
      <label for="input-email" i18n="@@Email">Электронная почта</label>
      <input nbInput
             fullWidth
             type="email"
             name="email"
             formControlName="email"
             id="input-email"
             placeholder="Электронная почта">
    </div>
  </div>
  <div class="form-content">
    <div class="form-control-group">
      <label for="input-text" i18n="@@YourIdea">Ваша идея</label>
      <textarea nbInput fullWidth
                name="text"
                formControlName="text"
                id="input-text"
                i18n-placeholder="@@Text"
                placeholder="Текст"></textarea>
    </div>
  </div>
  <div class="form-content">
    <app-uploader [accept]="accept" (upload)="onUpload($event)" [allowedMimeType]="allowedMimeTypes"/>
  </div>

  <nb-card-footer>
    <button nbButton
            size="large"
            [nbSpinner]="submitted" nbSpinnerStatus="control"
            [disabled]="!suggestForm.valid || submitted"
            status="primary"
            i18n="@@Send"
            type="submit">
      Отправить
    </button>
    <button type="button" size="large" nbButton (click)="close()" i18n="@@Cancel">Отмена</button>
  </nb-card-footer>
</form>
